import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

//Import style
import './style.scss';

// Define routes
import Routes from './routes';

const { detect } = require('detect-browser');
const browser = detect();

// Render App
hydrate(
    <BrowserRouter>
        <Routes browser={browser} />
    </BrowserRouter>,
    document.getElementById('root')
);
